import RunningLineCollection from './TrRunningLine.js';
import SearchCollection from './TrSearch.js';
import Tabs from './TrTabs.js';

function main() {
	new RunningLineCollection();
	new SearchCollection();
	new Tabs();

	const announcementBar = document.querySelector('.js-site-announcement-bar');
	const themeHeader = document.querySelector('theme-header');
	const search = document.querySelector('.tr-header-search-mobile');

	function toggleSearchSticky() {
		const offsetHeight =
			announcementBar.offsetHeight + themeHeader.offsetHeight;

		if (window.scrollY > offsetHeight) {
			search.classList.add('is-sticky');
		} else {
			search.classList.remove('is-sticky');
		}
	}

	toggleSearchSticky();

	window.addEventListener('scroll', toggleSearchSticky);
}

document.addEventListener('DOMContentLoaded', main);

if (Shopify && Shopify.designMode) {
	document.addEventListener('shopify:section:load', main);
}
